import { ErrorMessage, Field, useFormikContext } from "formik"
import OptionInterface from "../../Interfaces/OptionInterface";
import parse from 'html-react-parser';

interface SelectInterface {
    name: string,
    label: string,
    defaultText: string,
    defaultValue?: string | number | null,
    disabled?: boolean,
    onChange: ((value: string) => void),
    subtext?: string,
    options?: OptionInterface[]
    classes?: string
}

const Select = ({name, label, defaultText, onChange, subtext, options, disabled, defaultValue, classes}:SelectInterface) => {
    const context = useFormikContext<any>();
    const error = (context.errors[name] && context.touched[name]) == true;

    return (
        <div className={`${classes || ''}`}>
            <label htmlFor={name}>{label}</label>
            <Field
                className={error ? 'error' : ''}
                as="select"
                autoFocus={error}
                name={name}
                id={name}
                value={defaultValue ?? context.values[name]}
                disabled={disabled}
                onChange={(e: Event) => onChange((e.currentTarget as HTMLSelectElement).value)}>
                <option value={''}>{defaultText}</option>
                {options?.map((option, index) => (
                    <option key={index} value={option.value}>{option.text}</option>
                ))}
            </Field>
            {subtext && (
                <div className="subtext rte links-underline">{parse(subtext ?? '')}</div>
            )}
            <ErrorMessage name={name} component={"div"} className={"configurator-content__error rte links-underline"}/>
        </div>
    )
}

export default Select;